module.exports = __webpack_public_path__ + "img/pc-bg02.4b48a97e.png";